import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { showErrorToast, showSuccessToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { ITestWebhookRequest, ITestWebhookResponse } from "../../types/webhook";
import { savedSearchWebhooksQueryKeys } from "../key-factory/factory";

export const useTestSavedSearchWebhookMutation = () => {
    const dispatch = useDispatch();

    return useMutation({
        mutationKey: savedSearchWebhooksQueryKeys.test(),
        retry: 2,
        retryDelay: 200,
        mutationFn(payload: ITestWebhookRequest) {
            return salesApiService.management.testSavedSearchWebhookUrl(payload);
        },
        onSuccess(response: ITestWebhookResponse) {
            if (response.status === "ok") {
                dispatch(
                    showSuccessToast(
                        getToastItemComponent({
                            text: translate("si.management.saved-search-webhooks.test-success"),
                        }),
                    ),
                );
            } else {
                dispatch(
                    showErrorToast(
                        getToastItemComponent({
                            text: translate("si.management.saved-search-webhooks.test-failed", {
                                error: response.error,
                            }),
                        }),
                    ),
                );
            }
        },
    });
};
